import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useDarkMode } from '../context/DarkModeContext';

const DarkModeToggle = ({ className = "" }) => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <motion.button
      onClick={toggleDarkMode}
      className={`relative w-14 h-8 rounded-full p-1 transition-all duration-300 theme-toggle ${
        isDarkMode 
          ? 'bg-gradient-to-r from-indigo-600 to-purple-600' 
          : 'bg-gradient-to-r from-yellow-400 to-orange-500'
      } ${className}`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      layout
    >
      {/* Toggle Circle */}
      <motion.div
        className={`absolute top-1 w-6 h-6 rounded-full shadow-lg flex items-center justify-center ${
          isDarkMode ? 'bg-gray-800' : 'bg-white'
        }`}
        animate={{
          x: isDarkMode ? 22 : 2
        }}
        transition={{
          type: "spring",
          stiffness: 500,
          damping: 30
        }}
        layout
      >
        <motion.div
          key={isDarkMode ? 'moon' : 'sun'}
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          exit={{ scale: 0, rotate: 180 }}
          transition={{ duration: 0.2 }}
        >
          {isDarkMode ? (
            <Moon size={12} className="text-blue-300" />
          ) : (
            <Sun size={12} className="text-yellow-500" />
          )}
        </motion.div>
      </motion.div>

      {/* Background Icons */}
      <div className="absolute inset-0 flex items-center justify-between px-2">
        <motion.div
          animate={{ 
            opacity: isDarkMode ? 0.3 : 0.7,
            scale: isDarkMode ? 0.8 : 1 
          }}
          transition={{ duration: 0.2 }}
        >
          <Sun size={12} className="text-white" />
        </motion.div>
        <motion.div
          animate={{ 
            opacity: isDarkMode ? 0.7 : 0.3,
            scale: isDarkMode ? 1 : 0.8 
          }}
          transition={{ duration: 0.2 }}
        >
          <Moon size={12} className="text-white" />
        </motion.div>
      </div>

      {/* Glow Effect */}
      <motion.div
        className={`absolute inset-0 rounded-full blur-sm -z-10 ${
          isDarkMode 
            ? 'bg-gradient-to-r from-indigo-600 to-purple-600' 
            : 'bg-gradient-to-r from-yellow-400 to-orange-500'
        }`}
        animate={{
          opacity: [0.3, 0.6, 0.3]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </motion.button>
  );
};

export default DarkModeToggle; 